/* eslint-disable @typescript-eslint/no-explicit-any */
import { IMenuModel } from 'src/app/shared/components/properties-overview/models/IMenuModel';
import { ICapabilityModelDefinition } from 'src/app/shared/interfaces/capability-model-definition';

export class AssetCapabilityStateModel {
    public capabilityModelDefinition: ICapabilityModelDefinition;
    public uiCapabilityModel: any;
    public menus?: IMenuModel[];
}

export const assetCapabilityDefaults = {
    name: 'assetCapability',
    defaults: {
        capabilityModelDefinition: null as ICapabilityModelDefinition,
        uiCapabilityModel: null as any,
        menus: null as IMenuModel[],
    },
};
